<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="'ppm.title' | translate"></sm-page-header>
  <!-- Form -->
  <sm-ppm-inspect-content-block [id]="id" [version]="version" [downloadModel]="downloadModel"
    [downloadExcelModel]="downloadExcelModel" [refresh]="refreshFn"
    [meeting]="!!version"></sm-ppm-inspect-content-block>
</div>